module.exports = __webpack_public_path__ + "img/index-bg.3608cb78.png";